module.exports = __webpack_public_path__ + "img/ds1.5092f45a.png";